import React from 'react'
import { ThaiMeaningFullProps } from 'core/interfaces/dictionary-thai-interfaces'

type Props = {
   meanings: ThaiMeaningFullProps[]
}

// The chip label is the primary meaning (first segment before a `;`).
const shortLabel = (meaning: string) => {
   const first = (meaning || '').split(';')[0].trim()
   return first || meaning
}

// The gap left above a sense when a chip scrolls to it.
const SCROLL_GAP = 24

// The chips index the senses and jump to them. They carry no active/current
// state — every chip reads the same, whichever sense is on screen.
const SenseNavigator = ({ meanings }: Props) => {
   const scrollToSense = (event: React.MouseEvent, n: number) => {
      event.preventDefault()
      const el = document.getElementById(`sense-${n}`)
      if (!el) return
      const top = window.scrollY + el.getBoundingClientRect().top - SCROLL_GAP
      window.scrollTo({ top, behavior: 'smooth' })
   }

   return (
      <div className="mt-[4px]">
         <div className="flex items-center gap-[8px] flex-wrap">
            {meanings.map((meaning, index) => {
               const n = index + 1
               return (
                  <a
                     key={n}
                     href={`#sense-${n}`}
                     onClick={(event) => scrollToSense(event, n)}
                     className="no-underline inline-flex items-baseline gap-[7px] bg-white border-none rounded-full px-[14px] py-[6px] transition-transform duration-150 hover:-translate-y-[1px]"
                  >
                     <span className="text-[12px] font-bold text-textMuted">{n}</span>
                     <span className="text-[13px] font-semibold text-bodyBlack">
                        {shortLabel(meaning.meaning)}
                     </span>
                  </a>
               )
            })}
         </div>
      </div>
   )
}

export default SenseNavigator
